import { render, staticRenderFns } from "./CatalogProject.vue?vue&type=template&id=f7666826&scoped=true&"
import script from "./CatalogProject.vue?vue&type=script&lang=js&"
export * from "./CatalogProject.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProject.vue?vue&type=style&index=0&id=f7666826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7666826",
  null
  
)

export default component.exports